ixModuleRouting(
    "impactx.approval",
    {
        "/approvallistdone": {
            template: "<ixa-approval-list-done></ixa-approval-list-done>",
            templateUrl: "modules/approval/templates/approvallistdone.html",
            process: "ApprovalList",
            controller: "ApprovalListDoneCtrl",
            controllerAs: "approvalListDoneCtrl",
            workspace: "shop",
        },
        "/approvallistopen": {
            template: "<ixa-approval-list-open></ixa-approval-list-open>",
            templateUrl: "modules/approval/templates/approvallistopen.html",
            process: "ApprovalList",
            controller: "ApprovalListOpenCtrl",
            controllerAs: "approvalListOpenCtrl",
            workspace: "shop",
        },
        "/approvaldetailrequest/:id": {
            template: "<ixa-approval-detail-request></ixa-approval-detail-request>",
            templateUrl: "modules/approval/templates/approvaldetail.html",
            process: "ApprovalList",
            controller: "ApprovalDetailRequestCtrl",
            controllerAs: "approvalDetailCtrl",
            workspace: "shop",
        },
        "/approvaldetailrequest/:id/:messages/:warnings/:errors": {
            template: "<ixa-approval-detail-request></ixa-approval-detail-request>",
            templateUrl: "modules/approval/templates/approvaldetail.html",
            process: "ApprovalList",
            controller: "ApprovalDetailRequestCtrl",
            controllerAs: "approvalDetailCtrl",
            workspace: "shop",
        },
        "/approvaldetaildemand/:id": {
            template: "<ixa-approval-detail-demand></ixa-approval-detail-demand>",
            templateUrl: "modules/approval/templates/approvaldetail.html",
            process: "ApprovalList",
            controller: "ApprovalDetailDemandCtrl",
            controllerAs: "approvalDetailCtrl",
            workspace: "shop",
        },
        "/approvaldetaildemand/:id/:messages/:warnings/:errors": {
            template: "<ixa-approval-detail-demand></ixa-approval-detail-demand>",
            templateUrl: "modules/approval/templates/approvaldetail.html",
            process: "ApprovalList",
            controller: "ApprovalDetailDemandCtrl",
            controllerAs: "approvalDetailCtrl",
            workspace: "shop",
        },
        "/approvaldetailinvoice/:id": {
            template: "<ixa-approval-detail-invoice></ixa-approval-detail-invoice>",
            templateUrl: "modules/approval/templates/approvaldetail.html",
            process: "ApprovalList",
            controller: "ApprovalDetailInvoiceCtrl",
            workspace: "shop",
        },
        "/cateringapproval/:id": {
            templateUrl:
                "modules/approval/templates/cateringapproval.tmpl.html",
            process: "ApprovalList",
            controller: "CateringApprovalCtrl",
            controllerAs: "cateringApprovalCtrl",
            workspace: "shop",
        },
        "/contractchangelist": {
            template: "<ixa-contract-change-list></ixa-contract-change-list>",
            templateUrl:
                "modules/approval/templates/contractchange-list.tmpl.html",
            process: "ApprovalList",
            controller: "ContractChangeListCtrl",
            controllerAs: "contractChangeListCtrl",
            workspace: "shop",
        },
        "/contractchangedialog/:atiId": {
            template: "<ixa-contract-change-dialog></ixa-contract-change-dialog>",
            templateUrl: "modules/approval/templates/contractchange.tmpl.html",
            process: "ApprovalList",
            controller: "ContractChangeDialogCtrl",
            controllerAs: "contractChangeDialogCtrl",
            workspace: "shop",
        },
        '/custominvoiceapproval/:id/:atiId': {
            templateUrl: 'modules/invoice/templates/custominvoiceview.html',
            controller: 'CustomInvoiceViewCtrl',
            controllerAs: 'invoiceCtrl',
            process: 'ApprovalList',
            workspace: 'shop'
        },
        '/approvaldetailbudget/:atiId': {
            template: '<ixa-budget-approval></ixa-budget-approval>',
            process: 'ApprovalList',
            workspace: 'shop'
        }
    },
    ["ngRoute", "impactx.list"]
);
